import React, { useEffect } from "react";
import { AutocompleteInput, BooleanInput, DateInput, FormDataConsumer, ImageField, ImageInput, minValue, maxValue, number, NumberInput, REDUX_FORM_NAME, ReferenceInput, required, SelectInput, SimpleForm, TextInput, DisabledInput } from "react-admin";
import { change } from "redux-form";
import { categories, categoryOptions, applicationCategories, applicationCategoryOptions } from "./config";
import Axios from "axios";
import { ArrayInput, SimpleFormIterator } from 'react-admin';

const inflection = require("inflection");

const validateArrayMinOne = (value) => {
    if (!value || value.length < 1) {
        return 'You must add at least one promotion detail.';
    }
    return undefined;
};

export default ({mode, ...props}) => (
    <SimpleForm
        {...props}
        redirect="list"
        save={(data, redirect) => {
            const sanitized = {
                ...data,
                Currency: data.Currency === 'Not Applicable' ? null : data.Currency,
            };
            if (mode === "CREATE") {
                if (Array.isArray(sanitized.Details)) {
                    sanitized.Details = sanitized.Details.map(detail => ({
                        Active: (detail.Active !== undefined && detail.Active !== null) ? detail.Active : false,
                        Publish: (detail.Publish !== undefined && detail.Publish !== null) ? detail.Publish : false,
                        Balance: (detail.Balance !== undefined && detail.Balance !== null) ? detail.Balance : 0,
                        Limit: (detail.Limit !== undefined && detail.Limit !== null) ? detail.Limit : 0,
                        Points: (detail.Points !== undefined && detail.Points !== null) ? detail.Points : 0,
                        Currency: (detail.Currency !== undefined && detail.Currency !== null) ? detail.Currency : 'Not Applicable',
                        Image: (detail.Image !== undefined && detail.Image !== null) ? detail.Image : null,
                        ...detail, 
                    }));
                }
            }

            console.log(sanitized);
            props.save(sanitized, redirect);
        }}
    >
        <FormDataConsumer>
            {
                ({dispatch, ...rest}) => (
                    <SelectInput
                        choices={categoryOptions}
                        onChange={
                            () => [
                                "Ref",
                                "Rating",
                                "Address",
                                "City",
                                "Country",
                                "Image"
                            ].forEach(field => dispatch(change(REDUX_FORM_NAME, field, null)))
                        }
                        source="Category"
                        validate={[required()]}
                    />
                )
            }
        </FormDataConsumer>
        <FormDataConsumer>
            {
                ({ formData: { Category, hotel, ...formData }, dispatch, ...rest }) => Category === 'HOTEL' ? (
                    <BooleanInput
                        source="freeTextRef"
                        defaultValue={mode === 'EDIT' && !hotel}
                        onChange={
                            () => dispatch(change(REDUX_FORM_NAME, 'Ref', null))
                        }
                    />
                ) : undefined
            }
        </FormDataConsumer>
        <FormDataConsumer>
            {
                ({ formData: { Category, freeTextRef, hotel, ...formData}, resource, ...rest }) => {
                    if (freeTextRef === true) {
                        return (
                            <TextInput
                                fullWidth={true}
                                label={Category ? `${inflection.titleize(Category)} Reference` : "Reference"}
                                source="Ref"
                                validate={[required()]}
                            />
                        );
                    } else if (freeTextRef === true && (mode === 'EDIT' && !hotel)) {
                        return (
                            <TextInput
                                fullWidth={true}
                                label={Category ? `${inflection.titleize(Category)} Reference` : "Reference"}
                                source="Ref"
                                validate={[required()]}
                            />
                        );
                    }
                    switch (Category) {
                    case categories.HOTEL:
                        return (
                            <ReferenceInput
                                label="Hotel Reference"
                                reference="hotels"
                                resource={resource}
                                sort={{ field: 'Name', order: 'ASC' }}
                                source="Ref"
                                validate={[required()]}
                            >
                                <AutocompleteInput
                                    options={{fullWidth: true}}
                                    optionText={choice => `${choice.id} - ${choice.Name}`}
                                    translateChoice={false}
                                />
                            </ReferenceInput>
                        );
                    default:
                        return (
                            <TextInput
                                fullWidth={true}
                                label={Category ? `${inflection.titleize(Category)} Reference` : "Reference"}
                                source="Ref"
                                validate={[required()]}
                            />
                        );
                    }
                }
            }
        </FormDataConsumer>
        <FormDataConsumer>
            {
                ({ formData: { Category }, ...rest }) => Category === categories.HOTEL ? (
                    <NumberInput 
                        fullWidth={true}
                        source="Rating"
                        validate={[
                            // required(),
                            number(),
                            minValue(1),
                            maxValue(5),
                        ]}
                    />
                ) : undefined
            }
        </FormDataConsumer>
        <FormDataConsumer>
            {
                ({ formData: { Category }, ...rest }) => Category === categories.HOTEL ? (
                    <TextInput
                        fullWidth={true}
                        source="Address"
                        // validate={[required()]}
                    />
                ) : undefined
            }
        </FormDataConsumer>
        <FormDataConsumer>
            {
                ({ formData: { Category }, ...rest }) => Category === categories.HOTEL ? (
                    <TextInput
                        fullWidth={true}
                        source="City"
                        // validate={[required()]}
                    />
                ) : undefined
            }
        </FormDataConsumer>
        <FormDataConsumer>
            {
                ({ formData: { Category }, ...rest }) => Category === categories.HOTEL ? (
                    <TextInput
                        fullWidth={true}
                        source="Country"
                        // validate={[required()]}
                    />
                ) : undefined
            }
        </FormDataConsumer>
        <FormDataConsumer>
            {
                ({ formData: { Category }, ...rest }) => Category === categories.HOTEL ? (
                    <TextInput
                        fullWidth={true}
                        source="Description"
                        // validate={[required()]}
                    />
                ) : undefined
            }
        </FormDataConsumer>
        <DateInput
            defaultValue={new Date()}
            label="Booking From"
            source="BookingFrom"
            validate={[required()]}
        />
        <DateInput
            defaultValue={new Date()}
            label="Booking To"
            source="BookingTo"
            validate={[required()]}
        />
        <DateInput
            defaultValue={new Date()}
            label="Stay From"
            source="StayFrom"
            validate={[required()]}
        />
        <DateInput
            defaultValue={new Date()}
            label="Stay To"
            source="StayTo"
            validate={[required()]}
        />
        <FormDataConsumer>
            {
                ({dispatch, ...rest}) => (
                    <SelectInput
                        choices={applicationCategoryOptions}
                        label="Application Category"
                        onChange={() => dispatch(change(REDUX_FORM_NAME, 'AppliesTo', null))}
                        source="ApplicationCategory"
                        validate={[required()]}
                    />
                )
            }
        </FormDataConsumer>

        {mode === 'EDIT' ? (
            <>
            <FormDataConsumer>
            {
                ({ formData: { ApplicationCategory }, resource, ...rest }) => {
                    switch (ApplicationCategory) {
                        case applicationCategories.COUNTRY:
                            return (
                            <ReferenceInput
                                label="Promotion applies to all agent in"
                                reference="countries"
                                resource={resource}
                                sort={{ field: 'Name', order: 'ASC' }}
                                source="AppliesTo"
                                validate={[required()]}
                            >
                                <SelectInput
                                    fullWidth={true}
                                    optionText={choice => `${choice.id} - ${choice.Name}` }
                                />
                            </ReferenceInput>
                            );
                        // case applicationCategories.AGENT:
                        //     return (
                        //     <ReferenceInput
                        //         label="Promotion applies to all member of agent"
                        //         reference="agents"
                        //         resource={resource}
                        //         sort={{ field: 'Name', order: 'ASC' }}
                        //         source="AppliesTo"
                        //         validate={[required()]}
                        //     >
                        //         <AutocompleteInput
                        //             options={{fullWidth: true}}
                        //             optionText={choice => `${choice.id} - ${choice.Name}`}
                        //         />
                        //     </ReferenceInput>
                        //     );
                        default:
                            return (
                                <TextInput
                                    fullWidth={true}
                                    label="Promotion applies to"
                                    source="AppliesTo"
                                    validate={[required()]}
                                />
                            );
                    }
                }
            }
            </FormDataConsumer>
            <NumberInput
                fullWidth
                defaultValue={1}
                source="Points"
                disabled={ mode === "EDIT" ? true : false }
                validate={[required(), number()]}
            />
            {/* Old Calculation
            <NumberInput
                defaultValue={0}
                label="Gold Limit"
                source="GoldLimit"
                disabled={ mode === "EDIT" ? true : false }
                validate={[number()]}
            />
            <DisabledInput source="GoldBalance" />
            <NumberInput
                defaultValue={0}
                label="Silver Limit"
                source="SilverLimit"
                disabled={ mode === "EDIT" ? true : false }
                validate={[number()]}
            />
            <DisabledInput source="SilverBalance" /> 
            end old calculation */}
            <NumberInput
                fullWidth
                defaultValue={0}
                label="Limit"
                source="Limit"
                disabled={ mode === "EDIT" ? true : false }
                validate={[number()]}
            />
            <DisabledInput fullWidth source="Balance" />
            <FormDataConsumer>
                {({ dispatch, formData: { AppliesTo }, ...rest }) => {
                    useEffect(() => {
                        const fetchCurrency = async () => {
                            if (AppliesTo) {
                                try {
                                    const token = localStorage.getItem('token');
                                    const response = await Axios.get(
                                        `${process.env.REACT_APP_API_URL}/countries/${AppliesTo}`,
                                        {
                                            headers: {
                                                Authorization: `Bearer ${token}`,
                                            },
                                        }
                                    );

                                    const currency = response.data.Currency || 'Not Applicable';
                                    dispatch(change(REDUX_FORM_NAME, 'Currency', currency));
                                } catch (error) {
                                    dispatch(change(REDUX_FORM_NAME, 'Currency', 'Not Applicable'));
                                }
                            }
                        };

                        fetchCurrency();
                    }, [AppliesTo, dispatch]);

                    return (
                        <DisabledInput source="Currency" />
                    );
                }}
            </FormDataConsumer>
            <BooleanInput source="Active" label="Mark as active" defaultValue={false} />
            <FormDataConsumer>
                {
                    ({ formData: { Category }, ...rest }) => Category === categories.HOTEL ? (
                        <BooleanInput
                            defaultValue={false}
                            label="Display on Hotel Promotions page?"
                            source="Publish"
                            // validate={[required()]}
                        />
                    ) : undefined
                }
            </FormDataConsumer>
            <FormDataConsumer>
                {
                    ({ formData: { Category, Publish }, ...rest }) => Category === categories.HOTEL && Publish === true ? (
                        <ImageInput
                            accept="image/*"
                            // validate={[required()]}
                            source="Image"
                        >
                            <ImageField source="src" />
                        </ImageInput>
                    ) : undefined
                }
            </FormDataConsumer>
        </>
        ) : (
        <>
        <ArrayInput source="Details" label="Promotion Details" validate={validateArrayMinOne}>
            <SimpleFormIterator>
                <FormDataConsumer>
                    {({ getSource, scopedFormData: record, formData, dispatch }) => {

                        const [choices, setChoices] = React.useState([]);

                        React.useEffect(() => {
                            async function load() {
                                const token = localStorage.getItem("token");
                                const res = await Axios.get(
                                    process.env.REACT_APP_API_URL + "/countries",
                                    {
                                        headers: { Authorization: "Bearer " + token }
                                    }
                                );

                                const usedValues = (formData && formData.Details)
                                    ? formData.Details
                                        .map(d => d && d.AppliesTo)
                                        .filter(v => v !== undefined && v !== null)
                                    : [];

                                const current = record && record.AppliesTo ? record.AppliesTo : null;

                                const filtered = res.data.filter(country =>
                                    country.id === current || !usedValues.includes(country.id)
                                );

                                setChoices(filtered);
                            }

                            load();
                        }, [formData, record]);

                        return (
                            <SelectInput
                                label="Promotion applies to all agent in"
                                source={getSource("AppliesTo")}
                                validate={[required()]}
                                fullWidth
                                choices={choices}
                                optionText={choice => `${choice.id} - ${choice.Name}`}
                                optionValue="id"
                            />
                        );
                    }}
                </FormDataConsumer>
                <FormDataConsumer>
                {({ getSource, scopedFormData, dispatch }) => {
                    useEffect(() => {
                    // isi default Points kalau belum ada
                    if (scopedFormData && scopedFormData.Points === undefined) {
                        dispatch(change(REDUX_FORM_NAME, getSource('Points'), 1));
                    }
                    }, [scopedFormData, dispatch, getSource]);

                    return (
                    <NumberInput
                        label="Points"
                        source={getSource('Points')}
                        disabled={mode === 'EDIT'}
                        validate={[required(), number()]}
                    />
                    );
                }}
                </FormDataConsumer>
                {/* Old Calculation
                <NumberInput
                    defaultValue={0}
                    label="Gold Limit"
                    source="GoldLimit"
                    disabled={ mode === "EDIT" ? true : false }
                    validate={[number()]}
                />
                <DisabledInput source="GoldBalance" />
                <NumberInput
                    defaultValue={0}
                    label="Silver Limit"
                    source="SilverLimit"
                    disabled={ mode === "EDIT" ? true : false }
                    validate={[number()]}
                />
                <DisabledInput source="SilverBalance" /> 
                end old calculation */}
                <FormDataConsumer>
                {({ getSource, scopedFormData, dispatch }) => {
                    useEffect(() => {
                    // isi default Points kalau belum ada
                    if (scopedFormData && scopedFormData.Points === undefined) {
                        dispatch(change(REDUX_FORM_NAME, getSource('Limit'), 0));
                    }
                    }, [scopedFormData, dispatch, getSource]);

                    return (
                    <NumberInput
                        defaultValue={0}
                        label="Limit"
                        source={getSource('Limit')}
                        disabled={ mode === "EDIT" ? true : false }
                        validate={[number()]}
                    />
                    );
                }}
                </FormDataConsumer>
                <DisabledInput source="Balance" />
                <FormDataConsumer>
                    {({ dispatch, getSource, scopedFormData }) => {
                        useEffect(function () {
                        var appliesTo = scopedFormData && scopedFormData.AppliesTo;
                        if (!appliesTo) return;

                        async function fetchCurrency() {
                            try {
                            var token = localStorage.getItem("token");
                            var response = await Axios.get(
                                process.env.REACT_APP_API_URL + "/countries/" + appliesTo,
                                {
                                headers: { Authorization: "Bearer " + token },
                                }
                            );
                            var currency =
                                response.data && response.data.Currency
                                ? response.data.Currency
                                : "Not Applicable";

                            // arahkan ke field currency di array item ini
                            dispatch(change(REDUX_FORM_NAME, getSource("Currency"), currency));
                            } catch (e) {
                            dispatch(
                                change(REDUX_FORM_NAME, getSource("Currency"), "Not Applicable")
                            );
                            }
                        }

                        fetchCurrency();
                        }, [scopedFormData && scopedFormData.AppliesTo, dispatch]);

                        return <DisabledInput source={getSource("Currency")} label="Currency" />;
                    }}
                </FormDataConsumer>
                <BooleanInput source="Active" label="Mark as active" defaultValue={false} />
                <FormDataConsumer>
                {({ formData, scopedFormData }) => {
                    if (!formData || !formData.Details) return null;
                    const index = formData.Details.indexOf(scopedFormData);
                    if (index === -1) return null;

                    if (formData.Category === categories.HOTEL) {
                    return (
                        <BooleanInput
                        defaultValue={false}
                        label="Display on Hotel Promotions page?"
                        source={`Details[${index}].Publish`}
                        />
                    );
                    }

                    return null;
                }}
                </FormDataConsumer>
                <FormDataConsumer>
                {({ formData, scopedFormData }) => {
                    if (!formData || !formData.Details) return null;
                    const index = formData.Details.indexOf(scopedFormData);
                    if (index === -1) return null;

                    if (formData.Category === categories.HOTEL && scopedFormData && scopedFormData.Publish === true) {
                    return (
                        <ImageInput
                        accept="image/*"
                        source={`Details[${index}].Image`}
                        >
                        <ImageField source="src" />
                        </ImageInput>
                    );
                    }

                    return null;
                }}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
        </>
        )}
    </SimpleForm>
)